import { render, staticRenderFns } from "./HintModal.vue?vue&type=template&id=71157760"
import script from "./HintModal.vue?vue&type=script&lang=ts"
export * from "./HintModal.vue?vue&type=script&lang=ts"
import style0 from "./HintModal.vue?vue&type=style&index=0&id=71157760&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports